import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';

import {
  bibShape,
  availabilityShape,
  branchShape,
  libraryShape,
  holdingShape,
  subscriptionShape,
  userIdentityShape
} from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';

import BibsActions from 'app/actions/BibsActions';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities, selectAvailabilityEntities } from 'app/selectors/EntitiesSelector';
import {
  selectAvailabilityError,
  selectBibItemsForCurrentBib,
  selectHoldingsForCurrentBib,
  selectSubscriptionsForCurrentBib
} from 'app/selectors/bibs/AvailabilitySelector';
import { selectAllDigitalFormats } from 'app/selectors/bibs/DigitalFormatsSelector';
import { selectCurrentLibrary, selectActivePreferredBranches } from 'app/selectors/LibrarySelector';
import { selectCurrentAccount, selectCurrentUser } from 'app/selectors/AuthSelector';
import { trackHoldingsConsumeAccess, trackHoldingsView } from 'app/actions/AnalyticsGa4Actions';

import TransactPanel from './TransactPanel';

export class TransactPanelContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick({ title, uri }) {
    const bibId = this.props.bib.get('id');
    const metadata = {
      metadata_category_type: 'holdings_electronic_resource',
      metadata_value: uri
    };
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'availability-details',
      ui_component_type: 'link-text',
      ui_component_label: title
    };

    this.props.trackHoldingsConsumeAccess({ bibId, metadata, ui });
  }

  handleAvailabilityButtonClick() {
    const { intl } = this.props;
    const bibId = this.props.bib.get('id');
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'availability-details',
      ui_component_type: 'link-text',
      ui_component_label: intl.formatMessage({ id: 'availability_by_location' })
    };
    this.props.trackHoldingsView({ bibId, ui });
  }

  render() {
    return (
      <TransactPanel
        {...this.props}
        handleClick={this.handleClick}
        handleAvailabilityButtonClick={this.handleAvailabilityButtonClick}
      />
    );
  }
}

TransactPanelContainer.propTypes = {
  bib: bibShape.isRequired,
  bibItems: ImmutablePropTypes.list.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  realtimeAvailability: availabilityShape,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  digitalFormats: ImmutablePropTypes.list,
  availabilityError: PropTypes.string,
  currentLibrary: libraryShape.isRequired,
  holdings: ImmutablePropTypes.listOf(holdingShape).isRequired,
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape).isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentUser: userIdentityShape,
  trackHoldingsConsumeAccess: PropTypes.func,
  trackHoldingsView: PropTypes.func
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);
  const isAvailabilityLoaded = state.getIn(['bibs', 'availability', 'isLoaded'], false);
  const isTransactionsLoaded = state.getIn(['bibs', 'userTransactions', 'isLoaded'], false);

  return {
    bib,
    catalogBib,
    bibItems: selectBibItemsForCurrentBib(state),
    isLoaded: isAvailabilityLoaded && isTransactionsLoaded,
    realtimeAvailability: selectAvailabilityEntities(state).get(metadataId),
    digitalFormats: selectAllDigitalFormats(state).get(metadataId),
    preferredBranches: selectActivePreferredBranches(state),
    availabilityError: selectAvailabilityError(state),
    currentLibrary: selectCurrentLibrary(state),
    holdings: selectHoldingsForCurrentBib(state),
    subscriptions: selectSubscriptionsForCurrentBib(state),
    currentAccount: selectCurrentAccount(state),
    currentUser: selectCurrentUser(state)
  };
};

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch),
  trackHoldingsConsumeAccess: bindActionCreators(trackHoldingsConsumeAccess, dispatch),
  trackHoldingsView: bindActionCreators(trackHoldingsView, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TransactPanelContainer));
